export const getShadowRoot = (element) => {
    const root = element.getRootNode();
    const isShadowRoot = root instanceof ShadowRoot;
    if (!isShadowRoot)
        throw new Error("Element not within a ShadowDOM");
    return root;
};
